import { IniciativaFormatada } from 'types/iniciativa';
import { dedupedFetch } from './cache';
import { buscarIniciativasPorPlayer } from './iniciativa.service';
import { isCategoriaElbb } from 'utils/iniciativa-categoria';

const CACHE_TTL_MS = 30_000;

const isStatusInscrita = (status?: string) => String(status || '').trim().toLowerCase() === 'inscrita';

export const hasVinculoIniciativaInscritaPremio = (
  iniciativas: Pick<IniciativaFormatada, 'status' | 'categoryPremio'>[] = []
): boolean => {
  return iniciativas.some((iniciativa) => {
    const isInscrita = isStatusInscrita(iniciativa?.status);
    const isPremioBb = !isCategoriaElbb(iniciativa?.categoryPremio);
    return isInscrita && isPremioBb;
  });
};

export const canAccessMinhasIniciativas = async (userId?: string): Promise<boolean> => {
  if (!userId) {
    return false;
  }

  return dedupedFetch<boolean>(
    `minhas-iniciativas-eligibility:${userId}`,
    async () => {
      const iniciativas = await buscarIniciativasPorPlayer(userId);
      return hasVinculoIniciativaInscritaPremio(iniciativas);
    },
    CACHE_TTL_MS
  );
};
